if (!customElements.get("product-info")) {
	customElements.define(
		"product-info",
		class ProductInfo extends HTMLElement {
			abortController = undefined;
			onVariantChangeUnsubscriber = undefined;
			cartUpdateUnsubscriber = undefined;
			pendingRequestUrl = null;
			preProcessHtmlCallbacks = [];
			postProcessHtmlCallbacks = [];

			constructor() {
				super();
			}

			get variantSelectors() {
				return this.querySelector("variant-picker");
			}

			get productMedia() {
				return this.querySelector(
					`[id^="MediaGallery-${this.dataset.section}"]`
				);
			}

			get sectionId() {
				return this.dataset.originalSection || this.dataset.section;
			}

			get productUrl() {
				return this.dataset.url;
			}

			get productId() {
				return this.getAttribute("data-product-id");
			}

			get pickupAvailability() {
				return this.querySelector(`pickup-availability`);
			}

			get inventoryStatus() {
				return this.querySelector(`#Inventory-${this.dataset.section}`);
			}

			get sku() {
				return this.querySelector(`#Sku-${this.dataset.section}`);
			}

			get availability() {
				return this.querySelector(`#Availability-${this.dataset.section}`);
			}

			get enableVariantGroupImages() {
				return this.dataset.enableVariantGroupImages === "true" || false;
			}

			get disableDefaultSelectVariant() {
				return this.dataset.disableDefaultSelectVariant === "true" || false;
			}

			get productForm() {
				return this.querySelector("product-form");
			}

			get quantityInput() {
				return this.querySelector("quantity-input input");
			}

			getSelectedVariant(productInfoNode) {
				const selectedVariant = productInfoNode.querySelector(
					"variant-picker [data-selected-variant]"
				)?.innerHTML;
				return !!selectedVariant ? JSON.parse(selectedVariant) : null;
			}

			getVariantGroupImages() {
				return (
					JSON.parse(
						this.querySelector('#VariantGroupImages[type="application/json"]')
							.textContent
					) || {}
				);
			}

			getProductOptionByName(optionName, productData) {
				for (var i = 0; i < productData.options.length; i++) {
					var option = productData.options[i];
					if (option["name"] === optionName) {
						return option;
					}
				}
				return null;
			}

			async getProductData() {
				try {
					const response = await fetch(this.dataset.productUrl + ".js");
					if (!response.ok) {
						throw new Error(
							`Bad HTTP status of the request (${response.status}).`
						);
					}
					const data = await response.json();
					return data;
				} catch (err) {
					console.log(
						`An error occurred while processing the request. Error message: ${err.message}`
					);
				}
			}

			async init() {
				this.onVariantChangeUnsubscriber = window.FoxThemeEvents.subscribe(
					PUB_SUB_EVENTS.optionValueSelectionChange,
					this.handleOptionValueChange.bind(this)
				);

				if (this.enableVariantGroupImages) {
					this.variantGroupImages = this.getVariantGroupImages();
				}

				this.addEventListener("product-media:loaded", (evt) => {
					if (this.enableVariantGroupImages && this.variantGroupImages.enable) {
						this.updateMedia(evt.detail.currentVariant);
					}
				});

				this.productData = await this.getProductData();
				this.Notification = window.FoxTheme.Notification;

				this.mediaByVariantColor = [];
				this.productData.variants.forEach((variant) => {
					if (variant.featured_media) {
						if (!this.mediaByVariantColor[variant.featured_media.id]) {
							this.mediaByVariantColor[variant.featured_media.id] = [];
						}
						// 拿到当前选定swatch的选项值
						this.mediaByVariantColor[variant.featured_media.id].push(variant.options[0]);
					}
				});
				const selectedVariant = this.getSelectedVariant(this);
				selectedVariant && this.updateMedia(selectedVariant);
				selectedVariant && this.setOotd(selectedVariant);

				document.addEventListener("unmatchMobile", () => {
					this.productMedia && this.productMedia.currentVariant
						&& this.updateMedia(this.productMedia.currentVariant)
				});

				if (this.productData && this.disableDefaultSelectVariant) {
					this.handleDisableDefaultSelectVariant();
				}
			}

			initializeProductSwapUtility() {
				this.postProcessHtmlCallbacks.push((newNode) => {
					__reInitTooltip(newNode);
					window?.Shopify?.PaymentButton?.init();
					console.log("init");
					window?.ProductModel?.loadShopifyXR();
				});
			}

			connectedCallback() {
				this.initializeProductSwapUtility();
				this.init();

				this.initQuantityHandlers();
			}

			disconnectedCallback() {
				this.onVariantChangeUnsubscriber();
				this.cartUpdateUnsubscriber?.();
			}

			handleDisableDefaultSelectVariant() {
				const stickyAtc = document.querySelector(".sticky-atc-bar");
				let urlParams = new URLSearchParams(window.location.search);
				if (urlParams.has("variant")) return;

				if (stickyAtc) {
					stickyAtc.classList.add("f-hidden");
				}

				this.inventoryStatus && this.inventoryStatus.setAttribute("hidden", "");
				this.sku && this.sku.classList.add("hidden");
				this.availability && this.availability.classList.add("hidden");

				let isVariantChange = false;
				this.pickerFields = this.querySelectorAll("[data-picker-field]");

				this.pickerFields &&
					this.pickerFields.forEach((field) => {
						let optionName = field.dataset.optionName;
						let optionInfo = this.getProductOptionByName(
							optionName,
							this.productData
						);

						if (optionInfo && optionInfo.values.length > 1) {
							isVariantChange = true;
							let pickerType = field.dataset.pickerField;
							switch (pickerType) {
								case "select":
									let selectBox = field.querySelector("select");
									let option = document.createElement("option");
									option.text = this.dataset.variantOptionNoneText;
									option.setAttribute("disabled", "");
									option.setAttribute("selected", "");

									selectBox.add(option, 0);
									break;
								default:
									let checkedInputs = field.querySelectorAll("input:checked");
									checkedInputs &&
										checkedInputs.forEach(function (input) {
											input.removeAttribute("checked");
										});
									break;
							}

							field.dataset.selectedValue = "";
							if (field.querySelector(".selected-value")) {
								field.querySelector(".selected-value").textContent = "";
							}
						}
					});

				if (isVariantChange) {
					document
						.querySelectorAll(
							`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
						)
						.forEach((productForm) => {
							const input = productForm.querySelector('input[name="id"]');
							input.value = "";
						});

					const atcButton = this.querySelector('[name="add"]');
					const buyNowButton = this.querySelector(
						".shopify-payment-button__button"
					);

					atcButton.addEventListener(
						"click",
						this.handleDisableDefaultSelectVariantMessage.bind(this)
					);
					buyNowButton &&
						buyNowButton.addEventListener(
							"click",
							this.handleDisableDefaultSelectVariantMessage.bind(this)
						);
				}
			}

			handleDisableDefaultSelectVariantMessage(evt) {
				if (!this.currentVariant) {
					evt.preventDefault();
					this.pickerFields &&
						this.pickerFields.forEach((pickerField) => {
							if ("" === pickerField.dataset.selectedValue) {
								pickerField
									.closest(".variant-picker__field-wrapper")
									.classList.add("is-error");
							}
						});

					this.Notification.show({
						target: this.productForm,
						method: "appendChild",
						type: "warning",
						last: 3000,
						message: this.dataset.variantSelectionNeededText,
					});
				}
			}

			handleOptionValueChange({
				data: { event, target, selectedOptionValues },
			}) {
				if (!this.contains(event.target)) return;
				const productUrl =
					target.dataset.productUrl ||
					this.pendingRequestUrl ||
					this.dataset.productUrl;
				const shouldSwapProduct = this.dataset.productUrl !== productUrl;
				const shouldFetchFullPage =
					this.dataset.updateUrl === "true" && shouldSwapProduct;

				this.renderProductInfo({
					requestUrl: this.buildRequestUrlWithParams(
						productUrl,
						selectedOptionValues,
						shouldFetchFullPage
					),
					targetId: target.id,
					callback: shouldSwapProduct
						? this.handleSwapProduct(productUrl, shouldFetchFullPage)
						: this.handleUpdateProductInfo(productUrl),
				});
			}

			handleSwapProduct(productUrl, updateFullPage) {
				return (html) => {
					const selector = updateFullPage
						? "product-info[id^='MainProduct']"
						: "product-info";

					const variant = this.getSelectedVariant(html.querySelector(selector));

					this.updateURL(productUrl, variant?.id);

					if (updateFullPage) {
						const currentShareModal = document.getElementById(
							`PopupModal-Sharing-${this.sectionId}`
						);
						document.querySelector("head title").innerHTML =
							html.querySelector("head title").innerHTML;
						if (currentShareModal) document.body.removeChild(currentShareModal);

						HTMLUpdateUtility.viewTransition(
							document.querySelector("main"),
							html.querySelector("main"),
							this.preProcessHtmlCallbacks,
							this.postProcessHtmlCallbacks
						);
						HTMLUpdateUtility.viewTransition(
							document.getElementById("shopify-section-sticky-atc-bar"),
							html.getElementById("shopify-section-sticky-atc-bar"),
							this.preProcessHtmlCallbacks,
							this.postProcessHtmlCallbacks
						);
					} else {
						HTMLUpdateUtility.viewTransition(
							this,
							html.querySelector("product-info"),
							this.preProcessHtmlCallbacks,
							this.postProcessHtmlCallbacks
						);
					}
				};
			}

			handleUpdateProductInfo(productUrl) {
				return (html) => {
					const variant = this.getSelectedVariant(html);

					this.pickupAvailability?.update(variant);
					this.updateOptionValues(html);
					this.updateURL(productUrl, variant?.id);
					this.updateShareUrl(variant?.id);
					this.updateVariantInputs(variant?.id);
					this.toolTip = __reInitTooltip(this);

					if (!variant) {
						this.setUnavailable();
						return;
					}

					this.updateMedia(variant);
					this.setOotd(variant)

					const updateSourceFromDestination = (id) => {
						const source = html.getElementById(`${id}-${this.sectionId}`);
						const destination = this.querySelector(`#${id}-${this.sectionId}`);
						if (source && destination) {
							destination.innerHTML = source.innerHTML;
							destination.removeAttribute("hidden");
						}
					};

					updateSourceFromDestination("Price");
					updateSourceFromDestination("Volume");
					updateSourceFromDestination("PricePerItem");
					updateSourceFromDestination("Inventory");
					updateSourceFromDestination("Sku");
					updateSourceFromDestination("Availability");

					this.updateQuantityRules(this.sectionId, this.productId, html);
					updateSourceFromDestination("QuantityRules");
					updateSourceFromDestination("QuantityRulesCart");
					updateSourceFromDestination("VolumeNote");

					const addButtonUpdated = html.getElementById(
						`ProductSubmitButton-${this.sectionId}`
					);
					this.updateButton(
						addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
						window.FoxThemeStrings.soldOut
					);
					this.currentVariant = variant;

					window.FoxThemeEvents.emit(PUB_SUB_EVENTS.variantChange, {
						data: { variant, sectionId: this.sectionId, html },
					});

					document.dispatchEvent(
						new CustomEvent("variant:changed", {
							detail: {
								variant: this.currentVariant,
							},
						})
					);
				};
			}

			buildRequestUrlWithParams(
				url,
				optionValues,
				shouldFetchFullPage = false
			) {
				const params = [];

				!shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

				if (optionValues.length) {
					params.push(`option_values=${optionValues.join(",")}`);
				}

				return `${url}?${params.join("&")}`;
			}

			renderProductInfo({ requestUrl, targetId, callback }) {
				this.abortController?.abort();
				this.abortController = new AbortController();
				fetch(requestUrl, { signal: this.abortController.signal })
					.then((response) => response.text())
					.then((responseText) => {
						this.pendingRequestUrl = null;
						const html = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						callback(html);
					})
					.then(() => {
						// set focus to last clicked option value
						document.querySelector(`#${targetId}`)?.focus();
					})
					.catch((error) => {
						if (error.name === "AbortError") {
							console.log("Fetch aborted by user");
						} else {
							console.error(error);
						}
					});
			}

			updateOptionValues(html) {
				const variantSelects = html.querySelector("variant-picker");
				if (variantSelects) {
					HTMLUpdateUtility.viewTransition(
						this.variantSelectors,
						variantSelects,
						this.preProcessHtmlCallbacks
					);
				}
			}

			updateURL(url, variantId) {
				if (this.dataset.updateUrl === "false") return;
				window.history.replaceState(
					{},
					"",
					`${url}${variantId ? `?variant=${variantId}` : ""}`
				);
			}

			updateShareUrl(variantId) {
				if (!variantId) return;
				const shareButton = document.getElementById(
					`ShareButton-${this.dataset.section}`
				);
				if (!shareButton || !shareButton.updateUrl) return;
				shareButton.updateUrl(
					`${window.shopUrl}${this.dataset.url}?variant=${variantId}`
				);
			}

			updateVariantInputs(variantId) {
				document
					.querySelectorAll(
						`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
					)
					.forEach((productForm) => {
						const input = productForm.querySelector('input[name="id"]');
						input.value = variantId ?? "";
						input.dispatchEvent(new Event("change", { bubbles: true }));
					});
			}

			updateButton(disable = true, text) {
				const productForm = document.getElementById(
					`product-form-${this.sectionId}`
				);
				if (!productForm) return;
				const addButton = productForm.querySelector('[name="add"]');
				const addButtonText = productForm.querySelector(
					'[name="add"] > span:not(.f-icon)'
				);

				if (!addButton) return;
				if (disable) {
					addButton.setAttribute("disabled", "disabled");
					if (text) addButtonText.textContent = text;
				} else {
					addButton.removeAttribute("disabled");
					addButtonText.textContent = window.FoxThemeStrings.addToCart;
				}
			}

			// 更新媒体图
			updateMedia(variant) {
				if (!this.productMedia) return;

				// 媒体图切换
				var currentColor, newMediaVisible = false;
				var targetColor = variant.options[0];
				this.productData.media.forEach((media) => {
					if (this.mediaByVariantColor[media.id]) {
						currentColor = this.mediaByVariantColor[media.id];
					}
					var gallery = this.productMedia.querySelector(".f-product__media-list")
						, thumbMedia = this.productMedia.querySelector(".f-product__media-thumbnails");
					var mediaElement = gallery.querySelector(".f-product__media[data-media-id=\"".concat(media.id, "\"]"))
						, thumbMediaElement = thumbMedia?.querySelector(".f-product__media-thumbnails-item[data-media-id=\"".concat(media.id, "\"]"));
					if (mediaElement) {
						var showMedia = !!(currentColor && currentColor.includes(targetColor));
						if (mediaElement.getAttribute('aria-hidden') == showMedia.toString()) {
							newMediaVisible = true;
						}
						//Remove images which precede any variant image
						if (!currentColor) {
							mediaElement.remove();
							thumbMediaElement?.remove();
						}

						mediaElement.setAttribute('aria-hidden', !showMedia);
						thumbMediaElement?.setAttribute('ql-aria-hidden', !showMedia);

					}
				});
				this.selectedMedias = this.querySelectorAll('media-gallery:not(.ql_add) .f-product__media[aria-hidden="false"]');
				this.thumbSelectedMedias = this.querySelectorAll('media-gallery:not(.ql_add) .f-product__media-thumbnails-item[ql-aria-hidden="false"]');

				if (this.variantGroupImages && this.variantGroupImages.enable) {
					const isCarousel = this.productMedia.querySelector(".flickity-slider")
						? true
						: false;
					const initalMediaIds = this.productMedia?.domNodes?.medias.map(
						(item) => item.dataset.mediaId
					);
					const groupImages = this.variantGroupImages.mapping.find(
						(item) => Number(item.id) === variant.id
					);
					const currentVariantMedia = groupImages
						? groupImages.media
						: this.allMediaIds;

					if (!this.areArraysEquivalent(currentVariantMedia, initalMediaIds)) {
						const mainMedia = this.productMedia.querySelector(
							".f-product__media-list"
						);
						const thumbMedia = this.productMedia.querySelector(
							".f-product__media-thumbnails"
						);
						if (isCarousel) {
							const mainFlickity = window.FoxTheme.Flickity.data(mainMedia);

							let mediaToRemove =
								mainMedia.querySelectorAll(".f-product__media");
							mediaToRemove &&
								mediaToRemove.forEach(function (slide) {
									mainFlickity.remove(slide);
								});
							let mediaToShow = this.filteredMediaForSelectedVariant(
								this.productMedia.domNodes.medias,
								currentVariantMedia
							);

							mediaToShow.forEach(function (slide, index) {
								const zoomButton = slide.querySelector(".js-photoswipe--zoom");
								if (zoomButton) {
									zoomButton.setAttribute("data-media-index", index);
								}
								slide.setAttribute("data-media-index", index);
								slide.setAttribute("data-index", index);
								mainFlickity.append(slide);
							});

							if (thumbMedia && this.productMedia.domNodes.thumbnailItems) {
								const thumbnailsFlickity =
									window.FoxTheme.Flickity.data(thumbMedia);

								let thumbsToRemove = thumbMedia.querySelectorAll(
									".f-product__media-thumbnails-item"
								);
								thumbsToRemove &&
									thumbsToRemove.forEach(function (slide) {
										thumbnailsFlickity.remove(slide);
									});

								let thumbsToShow = this.filteredMediaForSelectedVariant(
									this.productMedia.domNodes.thumbnailItems,
									currentVariantMedia
								);
								thumbsToShow.forEach(function (slide, index) {
									slide.setAttribute("data-thumbnail-index", index);
									slide.setAttribute("data-index", index);
									thumbnailsFlickity.append(slide);
								});

								thumbMedia.classList.remove(
									"disable-transition",
									"md:disable-transition"
								);
								if (thumbsToShow.length < 5) {
									thumbMedia.classList.add("disable-transition");
								}
								if (thumbsToShow.length < 6) {
									thumbMedia.classList.add("md:disable-transition");
								}
								thumbnailsFlickity.option({
									wrapAround: thumbsToShow.length > 5,
								});
								thumbnailsFlickity.reloadCells();
								thumbnailsFlickity.reposition();
							}

							mainFlickity.select(0, false, false);
						} else {
							let mediaToShow = this.filteredMediaForSelectedVariant(
								this.productMedia.domNodes.medias,
								currentVariantMedia
							);
							mainMedia.innerHTML = "";
							mediaToShow.forEach((item, index) => {
								const zoomButton = item.querySelector(".js-photoswipe--zoom");
								if (zoomButton) {
									zoomButton.setAttribute("data-media-index", index);
								}
								item.setAttribute("data-media-index", index);
								item.setAttribute("data-index", index);
								mainMedia.append(item);
							});
						}

						// Re-init Photoswipe
						if (this.productMedia && this.productMedia.enableZoom) {
							this.productMedia.lightbox &&
								this.productMedia.lightbox.destroy();
							this.productMedia.initImageZoom();
						}
					}

					this.productMedia.removeAttribute("data-media-loading");
				} else {
					if (!variant.featured_media) return;
					if (typeof this.setActiveMedia === "function") {
						this.setActiveMedia(variant.featured_media.id);
					}

				}
			}

			// ootd 关联搭配
			async setOotd(variant) {
				const flickityEls = document.querySelectorAll('flickity-component');
				const ootd = this.querySelector('#ql-ootd');
				const ootdTitle = this.querySelector('#ql-ootd-title');
				const ootdContainer = this.querySelector('ootd-container');
				if (!ootdContainer) return;

				// 元字段 ootd数据
				const _ql_ootd_arr = JSON.parse(ootd.querySelector('#_ql_ootd_arr').innerHTML);
				if (_ql_ootd_arr?.length <= 0) return;

				// 隐藏标题和上一次显示的关联搭配产品
				const ootdItems = ootdContainer.querySelectorAll('ootd-item');
				ootdItems.forEach(item => {
					item.style.display = "none";
				});
				ootdTitle.style.display = "none";

				const arr_ootd = _ql_ootd_arr.filter((v, i) => variant.option1 === v.color);
				if (arr_ootd.length <= 0) return;

				// 查找之前是否已渲染过关联的产品
				let hasootdItems = false;
				arr_ootd.forEach(this_ootd => {
					const thisOotdItem = ootdContainer.querySelectorAll(`ootd-item[data-ootd-handle="${this_ootd.ootd_handle}"]`);
					if (thisOotdItem.length > 0) {
						hasootdItems = true;
						thisOotdItem.forEach(item => {
							// 选中指定颜色
							let select = this.querySelector(`.product-card__options .variant-picker__field input[value="${this_ootd.ootd_color}"]`);
							if(!select) return;
							select.checked = true;
							const selectOptions = item.getSelectOptions();
            				item.changeVariantId(selectOptions);

							item.style.display = "block";
						});

						// ootd指定显示complete the look按钮 的 移动端媒体元素
						this.setOotdBtn(this_ootd.img_pos);
					}
				});
				if (hasootdItems) {
					ootdTitle.style.display = "block";
					flickityEls.forEach(flickityEl => {
						flickityEl.update();
					});
					return;
				}

				// 没有渲染关联产品时，ajax请求并插入到页面
				Promise.allSettled(
					arr_ootd.map(this_ootd =>
						fetch(`${window.location.origin}/products/${this_ootd.ootd_handle}?view=card-item`)
							.then((response) => response.text())
					)
				).then(results => {
					const fragment = new DocumentFragment();
					results.forEach((result, i) => {
						const html = new DOMParser().parseFromString(
							result.value,
							"text/html"
						);
						const color = arr_ootd[i].color;
						const ootd_color = arr_ootd[i].ootd_color;
						const handle = arr_ootd[i].handle;
						const ootd_handle = arr_ootd[i].ootd_handle;
						const item = html.querySelector('.ootd-item.product-card');
						const ootdItem = document.createElement('ootd-item')
						ootdItem.setAttribute('data-color', color);
						ootdItem.setAttribute('data-ootd-color', ootd_color);
						ootdItem.setAttribute('data-handle', handle);
						ootdItem.setAttribute('data-ootd-handle', ootd_handle);
						ootdItem.appendChild(item);

						if (item) fragment.appendChild(ootdItem);

						this.setOotdBtn(arr_ootd[i].img_pos);
					});
					ootdContainer.appendChild(fragment);
					if(ootdContainer.querySelectorAll('ootd-item')?.length > 0 ) ootdTitle.style.display = "block";
					ootdContainer.querySelectorAll('ootd-item').forEach((item) => {
						item.init();
					});
					flickityEls.forEach(flickityEl => {
						flickityEl.update();
					});
				});
			}

			// ootd 移动端 指定媒体图显示关联产品的锚点按钮
			setOotdBtn(pos) {
				const mobileMedias = this.querySelectorAll('media-gallery.ql_add .f-product__media responsive-image');
				if (mobileMedias.length <= 0) return;
				const mobileOotdMedia = mobileMedias[pos - 1];
				const aEl = document.createElement('a');
				aEl.setAttribute('href', '#ql-ootd-anchor');
				aEl.setAttribute('class', 'ql-ootd-link btn');
				aEl.innerHTML = 'complete the look';
				mobileOotdMedia.appendChild(aEl);
			}

			setActiveMedia(mediaId) {
				const selectedMedia = this.productMedia.domNodes.mediaGallery.querySelector(
					`[data-media-id="${mediaId}"]`
				);
				if (!selectedMedia) return;
				const mediaIndex = Number(selectedMedia.dataset.mediaIndex);
				const quickView = this.firstElementChild?.classList.contains('f-product-quickview');


				if (this.mediaLayout === "carousel") {
					this.productMedia.mediaGallery &&
						this.productMedia.mediaGallery.select(mediaIndex, false, true);
				}
				else if (FoxThemeSettings.isMobile || quickView) {
					this.querySelector("media-gallery.ql_add")?.remove();
					// const medias = this.querySelectorAll('media-gallery:not(.ql_add) .f-product__media.is-selected,media-gallery:not(.ql_add) .f-product__media[aria-hidden="false"]');

					const flickity_counter_clone = this.productMedia.querySelector(".flickity-page-counter").cloneNode(!0);
					let media_gallery_clone = this.productMedia.cloneNode(!0);
					let is_layout_carousel = "carousel" === this.productMedia.mediaLayout, mediaList,
						thumb_gallery = media_gallery_clone.querySelector(".f-product__media-thumbnails-wrapper flickity-component");
					if (flickity_counter_clone.querySelector(".flickity-counter--current").innerText = 1,
						flickity_counter_clone.querySelector(".flickity-counter--total").innerText = this.selectedMedias.length,
						media_gallery_clone.querySelector("[data-media-viewer] flickity-component").innerHTML = flickity_counter_clone?.outerHTML,
						mediaList = media_gallery_clone.querySelector('[data-media-viewer] flickity-component'),
						this.selectedMedias.forEach((element, index) => {
							const e = element.cloneNode(true);
							e.setAttribute('data-media-index', index);
							e.setAttribute('aria-hidden', false);
							mediaList.appendChild(e);
						}),
						media_gallery_clone.classList.add("ql_add"),
						quickView && (media_gallery_clone.classList.add("ql_quick-view"),
							(thumb_gallery.innerHTML = ''),
							this.thumbSelectedMedias.forEach((element, index) => {
								const e = element.cloneNode(true);
								e.setAttribute('data-thumbnail-index', index);
								e.setAttribute('ql-aria-hidden', false);
								thumb_gallery.appendChild(e);
							})
						),


						media_gallery_clone.classList.remove("hidden"),
						media_gallery_clone.classList.remove("mb:block"),

						this.productMedia.parentElement.appendChild(media_gallery_clone),
						media_gallery_clone = this.querySelector("media-gallery.ql_add"),
						is_layout_carousel
					) {
						let main_gallery = media_gallery_clone.querySelector("[data-media-viewer] flickity-component");

						if (quickView) {
							thumb_gallery = media_gallery_clone.querySelector(".f-product__media-thumbnails-wrapper flickity-component");
							let thumb_options = JSON.parse(thumb_gallery.getAttribute("data-slider-options"));
							let f = thumb_options.setGallerySize = this.thumbSelectedMedias.length > 5 ? false : true;
							// thumb_options.asNavFor = ".ql_add #Media-Gallery-product-quickview";
							// thumb_options.wrapAround = !1;
							// thumb_options.setGallerySize = !f;
							// thumb_options.freeScroll = f;

							// thumb_options.contain = f;


							thumb_options =
							{
								asNavFor: ".ql_add #Media-Gallery-product-quickview",
								contain: true,
								pageDots: false,
								cellAlign: "left",
								setGallerySize: false,
								wrapAround: !f
							};


							thumb_gallery.setAttribute("data-slider-options", JSON.stringify(thumb_options));
							// thumb_gallery?.initSlider();
						}
						try {
							main_gallery.destroy(),
								thumb_gallery?.destroy()
						} catch (err) { }
						main_gallery.initSlider();
						// thumb_gallery?.initSlider();

					}

					let modal_gallery = this.querySelector("flickity-component")
					"function" == typeof modal_gallery.connectedCallback && modal_gallery.connectedCallback()

				} else {
					this.productMedia.scrollIntoView(selectedMedia);
				}
			}

			setUnavailable() {
				this.updateButton(true, window.FoxThemeStrings.unavailable);

				const selectors = [
					"Price",
					"Inventory",
					"Sku",
					"PricePerItem",
					"VolumeNote",
					"Volume",
					"QuantityRules",
					"QuantityRulesCart",
				]
					.map((id) => `#${id}-${this.sectionId}`)
					.join(", ");
				document
					.querySelectorAll(selectors)
					.forEach((selector) => selector.setAttribute("hidden", ""));
			}

			areArraysEquivalent(firstArray, secondArray) {
				if (!Array.isArray(firstArray) || !Array.isArray(secondArray)) {
					return false;
				}

				if (firstArray.length !== secondArray.length) {
					return false;
				}

				const sortedFirstArray = [...firstArray].sort();
				const sortedSecondArray = [...secondArray].sort();

				return sortedFirstArray.every(
					(value, index) => value === sortedSecondArray[index]
				);
			}

			filteredMediaForSelectedVariant(items, currentVariantMedia) {
				let index = 0;
				let prioritizedResults = [];
				let otherResults = [];
				items.forEach((item) => {
					const dataIdMedia = item.dataset.mediaId;
					if (currentVariantMedia && currentVariantMedia.length > 0) {
						if (currentVariantMedia.includes(dataIdMedia)) {
							item.dataset.index = index++;
							prioritizedResults.push(item);
						}

						if (item.dataset.mediaType !== "image") {
							item.dataset.index = index++;
							otherResults.push(item);
						}
					} else {
						item.dataset.index = index++;
						prioritizedResults.push(item);
					}
				});

				const sortByVariantOrder = (a, b) => {
					const indexA = currentVariantMedia.indexOf(a.dataset.mediaId);
					const indexB = currentVariantMedia.indexOf(b.dataset.mediaId);
					return indexA - indexB;
				};

				prioritizedResults.sort(sortByVariantOrder);

				const results = [...prioritizedResults, ...otherResults];

				return results;
			}

			initQuantityHandlers() {
				if (!this.quantityInput) return;

				this.setQuantityBoundries();
				if (!this.hasAttribute("data-original-section-id")) {
					this.cartUpdateUnsubscriber = FoxThemeEvents.subscribe(
						PUB_SUB_EVENTS.cartUpdate,
						this.fetchQuantityRules.bind(this)
					);
				}
			}

			setQuantityBoundries() {
				FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityBoundries, {
					data: {
						sectionId: this.sectionId,
						productId: this.productId,
					},
				});
			}

			fetchQuantityRules() {
				const currentVariantId = this.productForm?.variantIdInput?.value;
				if (!currentVariantId) return;

				fetch(
					`${this.getAttribute(
						"data-product-url"
					)}?variant=${currentVariantId}&section_id=${this.sectionId}`
				)
					.then((response) => response.text())
					.then((responseText) => {
						const parsedHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.updateQuantityRules(
							this.sectionId,
							this.productId,
							parsedHTML
						);
					})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => { });
			}

			updateQuantityRules(sectionId, productId, parsedHTML) {
				if (!this.quantityInput) return;

				FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityRules, {
					data: {
						sectionId,
						productId,
						parsedHTML,
					},
				});

				this.setQuantityBoundries();
			}
		}
	);
}
